<template>
  <div>
    <!-- 导航栏 -->
    <Navbar />

    <!-- 轮播图 -->
    <div class="swiper-container">
      <div class="swiper-wrapper" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
        <!-- 轮播项1 -->
        <div class="swiper-slide slide-bg">
          <div class="slide-content">
            <h1>专业图像验证云识别服务</h1>
            <p>验证识别快又准 | 自动接入很轻松</p>
            <button class="banner-btn">立即接入</button>
          </div>
        </div>
        <!-- 轮播项2 -->
        <div class="swiper-slide">
          <div class="slide-content">
            <h1>定制开发全方位满足需求</h1>
            <p>模型定制快准狠 | 售后运维有保障</p>
            <button class="banner-btn">立即接入</button>
          </div>
        </div>
        <!-- 轮播项3 -->
        <div class="swiper-slide">
          <div class="slide-content">
            <h1>扫码关注公众号免费领取调用次数</h1>
            <p>每日签到有礼 | 新用户专享福利</p>
            <button class="banner-btn success">立即关注</button>
          </div>
        </div>
      </div>
      <!-- 轮播圆点 -->
      <div class="swiper-pagination">
        <span
          v-for="(_, i) in 3"
          :key="i"
          :class="{ active: currentSlide === i }"
          @click="goToSlide(i)"
        ></span>
      </div>
    </div>

    <!-- 我们的优势 -->
    <div class="section section-why">
      <div class="container">
        <div class="title">
          <h3>OUR ADVANTAGES</h3>
          <h2>我们的优势</h2>
        </div>
        <div class="card-grid">
          <div class="card"><h3>识别响应速度快</h3><p>1~2秒快速获取结果</p></div>
          <div class="card"><h3>秒级返回技术</h3><p>AI自动学习，告别人力</p></div>
          <div class="card"><h3>节省成本</h3><p>价格更低，成本更省</p></div>
          <div class="card"><h3>稳定云架构</h3><p>24小时不间断服务</p></div>
          <div class="card"><h3>多语言支持</h3><p>Python/PHP/Java 一键接入</p></div>
          <div class="card"><h3>安全保障</h3><p>数据安全，隐私保护</p></div>
        </div>
      </div>
    </div>

    <!-- 验证码识别服务介绍 -->
    <div class="section section-service">
      <div class="container">
        <div class="title">
          <h3>SERVICE INTRODUCTION</h3>
          <h2>验证码识别服务</h2>
        </div>
        <div class="card-grid">
          <div class="card"><h3>全类型验证码支持</h3><p>字母数字、计算题、滑块、点选、中英文、图标验证码全覆盖</p></div>
          <div class="card"><h3>AI智能识别</h3><p>深度学习模型，干扰线、模糊、变形都能精准识别</p></div>
          <div class="card"><h3>API一键接入</h3><p>HTTP接口调用，一行代码集成，支持所有编程语言</p></div>
          <div class="card"><h3>高准确率</h3><p>常规验证码识别率99%，复杂场景稳定高效</p></div>
          <div class="card"><h3>高并发支持</h3><p>云端分布式架构，批量请求不卡顿，自动负载均衡</p></div>
          <div class="card"><h3>免费额度体验</h3><p>新用户注册即送次数，低门槛测试，满意再付费</p></div>
        </div>
      </div>
    </div>

    <!-- 底部注册板块 -->
    <div class="section section-register">
      <div class="container">
        <h2>选择我们，立即体验</h2>
        <button class="banner-btn" @click="$router.push('/register')">立即注册</button>
      </div>
    </div>

    <!-- 页脚 -->
    <div class="footer">
      <div class="container">
        <p>鱿鱼云码 - 智能验证码识别平台 © 2026 版权所有</p>
      </div>
    </div>

    <!-- 悬浮客服按钮（Vant2 无 FloatingBubble，用自定义替代） -->
    <div class="floating-btn" @click="goService">💬</div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'

export default {
  name: 'Home',
  components: { Navbar },
  data() {
    return {
      currentSlide: 0,
      timer: null
    }
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    startAutoPlay() {
      this.timer = setInterval(() => {
        this.currentSlide = (this.currentSlide + 1) % 3
      }, 3000)
    },
    goToSlide(i) {
      this.currentSlide = i
    },
    goService() {
      this.$router.push('/home')
    }
  }
}
</script>

<style scoped>
/* 轮播图 */
.swiper-container {
  width: 100%;
  height: 500px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  overflow: hidden;
  background: #002080;
}
.swiper-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease;
}
.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #002080 0%, #0044cc 100%);
}
.slide-bg {
  background-image: url('../assets/1.jpg');
  background-size: 100% auto;
  background-position: center top;
  background-repeat: no-repeat;
}
.slide-content h1 {
  font-size: 36px;
  margin-bottom: 20px;
}
.slide-content p {
  font-size: 18px;
  margin-bottom: 30px;
}
.banner-btn {
  padding: 14px 35px;
  background: #fff;
  color: #0066ff;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
}
.banner-btn:hover { opacity: 0.9; }
.banner-btn.success { background: #07c160; color: #fff; }
.swiper-pagination {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}
.swiper-pagination span {
  width: 12px;
  height: 12px;
  background: rgba(255,255,255,0.5);
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.3s;
}
.swiper-pagination span.active { background: #fff; }

/* 板块 */
.section {
  padding: 60px 0;
  text-align: center;
}
.title h3 { color: #666; font-size: 16px; margin-bottom: 8px; }
.title h2 { font-size: 28px; margin-bottom: 40px; }
.section-service { background: #fff; }

/* 卡片 */
.card-grid { display: flex; flex-wrap: wrap; gap: 24px; justify-content: center; }
.card {
  flex: 1 1 280px;
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  transition: transform 0.3s;
}
.card:hover { transform: translateY(-5px); }
.card h3 { margin-bottom: 12px; color: #333; }
.card p { color: #666; font-size: 14px; }

/* 底部注册 */
.section-register { background: #0066ff; color: #fff; padding: 60px 0; }
.section-register h2 { margin-bottom: 20px; }

/* 悬浮按钮 */
.floating-btn {
  position: fixed;
  right: 20px;
  bottom: 80px;
  width: 50px;
  height: 50px;
  background: #0066ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0,102,255,0.4);
  z-index: 999;
  transition: transform 0.2s;
}
.floating-btn:hover { transform: scale(1.1); }
</style>
